






















import { computed, defineComponent } from '@vue/composition-api'
import TechnicalSkills from './TechnicalSkills.vue'
import store from '@/store'
import { TechnicalExperienceActions } from '@/store/modules/technical-experience/actions'
import { TechnicalExperienceGetters } from '@/store/modules/technical-experience/getters'
import { TechnicalExperienceInterface } from '@/store/modules/technical-experience/types'

export default defineComponent({
  name: 'TechnicalExperience',
  components: {
    TechnicalSkills
  },
  setup() {
    const experienceData = computed<Array<TechnicalExperienceInterface>>(() => store.getters[TechnicalExperienceGetters.All])

    store.dispatch(TechnicalExperienceActions.SetTechnicalExperience)

    return{
      experienceData
    }
  }
})
